// Generated from contracts/http/openapi.v1.json.
// Run npm run generate:api-client; do not edit by hand.

export const API_V1_BASE_PATH = "/api/v1";

export const apiV1Paths = Object.freeze({
  createMindMap: () => "/api/v1/mindmaps",
  deleteMindMap: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)),
  getMindMapById: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)),
  getMindMapSharing: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/sharing",
  getMindMapThumbnail: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/thumbnail",
  getMyMindMap: () => "/api/v1/mindmaps/me",
  listMindMaps: () => "/api/v1/mindmaps",
  removeMindMapMember: (id, userId) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/members/" + encodeURIComponent(String(userId)),
  removeSavedMindMapLink: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/saved-link",
  saveMindMapById: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)),
  saveMindMapLink: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/saved-link",
  saveMyMindMap: () => "/api/v1/mindmaps/me",
  updateMindMapLinkAccess: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/link-access",
  updateMindMapTitle: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/title",
  uploadMindMapThumbnail: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/thumbnail",
  upsertMindMapMember: (id) => "/api/v1/mindmaps/" + encodeURIComponent(String(id)) + "/members",
});
